import ls from 'local-storage';

const ANCHOR_KEY = 'window.location.hash';
const EXTRACT_ANCHOR = /^.*?#(.*)/;

function get() {
  ls.backend(sessionStorage);
  return ls.get(ANCHOR_KEY);
}

function set(value) {
  ls.backend(sessionStorage);
  ls.set(ANCHOR_KEY, value);
}

function clean(state) {
  if (!state) return '';
  return state.replace(EXTRACT_ANCHOR, '#$1');
}

export function saveState(state) {
  const cleanState = clean(state);
  set(cleanState);
  window.location.hash = cleanState;
  // TODO, back button misbehaves now
}

export function restoreState() {
  saveState(get());
}
